import component from './zh-HK/component';
import globalHeader from './zh-HK/globalHeader';
import menu from './zh-HK/menu';
import pages from './zh-HK/pages';
import pwa from './zh-HK/pwa';
import settingDrawer from './zh-HK/settingDrawer';
import settings from './zh-HK/settings';

export default {
  'navBar.lang': '語言',
  'layout.user.link.help': '幫助',
  'layout.user.link.privacy': '私隱',
  'layout.user.link.terms': '條款',
  'app.preview.down.block': '下載此頁面到本地項目',
  'app.welcome.link.fetch-blocks': '獲取全部區塊',
  'app.welcome.link.block-list': '基於 block 開發，快速構建標準頁面',
  ...pages,
  ...globalHeader,
  ...menu,
  ...settingDrawer,
  ...settings,
  ...pwa,
  ...component,
};
